/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import axios from 'axios';
import Amplify, { Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import PortalAuth from '../../utils/Auth';
import { getLogo, getTitle } from '../../brand';
import { getBackendBaseUrl, fetchBackendUrl } from '../../constants';
import styles from './authentication.module.scss';
import LoginForm from './components/LoginForm';
import ForceChangePasswordForm from './components/ForceChangePasswordForm';
import ForgotPasswordForm from './components/forgotPassword/ForgotPasswordForm';
import NewPassword from './components/forgotPassword/NewPassword';
import { fetchUserProfile, updateUserProfile } from './redux/actions';
import OTPLoginForm from './components/OTPLoginForm';
import OTPForm from './components/OTPForm';
import PasswordForm from './components/PasswordForm';
import Loading from '../../components/loading';
import { LOGIN_ROUTE, BASENAME } from '../../constants/RouterConstants';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 'login',
      loadingStatus: false,
      errors: {
        phoneEmpty: true,
        passwordEmpty: true,
        invalidCredentials: false,
        invalidPassword: false,
        phoneInvalid: false,
        codeEmpty: true
      },
      blurredFields: {
        phone: false,
        password: false,
        code: false,
        email: false
      },
      cognitoPhoneError: false,
      cognitoCodeError: false,
      resendSuccess: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleInputBlurred = this.handleInputBlurred.bind(this);
    this.handleAuthError = this.handleAuthError.bind(this);
    this.handlePath = this.handlePath.bind(this);
  }

  componentDidMount() {
    if (PortalAuth.getInstance().isAuthenticated()) {
      this.handlePath();
    }
    if (localStorage.checkbox && localStorage.phone !== '') {
      this.setState({
        phone: localStorage.username,
        password: localStorage.password
      });
    }
  }


  validateFormFields(inputType, value) {
    let errors = {};
    let emailValid;
    switch (inputType) {
      case 'email':
        if (value === '') {
          errors = Object.assign(errors, {
            emailEmpty: true,
            emailInvalid: false,
            emailMobileDeviceLogin: false
          });
        } else if (value?.startsWith('airport+') && value?.endsWith('@aerosimple.com')
            && value?.indexOf('+') !== value?.lastIndexOf('+')) {
              errors = Object.assign(errors, {
                emailEmpty: false,
                emailMobileDeviceLogin: true
              });
        } else {
          emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
          errors = Object.assign(errors, {
            emailEmpty: false,
            emailInvalid: !emailValid
          });
        }
        break;
      case 'mailPassword':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      case 'password':
        errors = Object.assign(errors, { passwordEmpty: value === '' });
        break;
      case 'phone':
        if (value === '' || value === '+') {
          errors = Object.assign(errors, { phoneEmpty: true, emailInvalid: false });
        }
        if (value !== '+') {
          errors = Object.assign(errors, { phoneEmpty: false, emailInvalid: false });
        }
        break;
      case 'otp':
        if (value !== '') {
          errors = Object.assign(errors, { codeEmpty: false });
        }
        break;
      default:
        break;
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, errors)
    }));
  }


  handleInputChange(inputType, value) {
    const { cognitoPhoneError, cognitoCodeError } = this.state;
    if (value !== '' && cognitoPhoneError === true) {
      this.setState({ cognitoPhoneError: false });
    } else if (value !== '' && cognitoCodeError === true) {
      this.setState({ cognitoCodeError: false });
    }
    this.setState({
      [inputType]: value
    }, () => this.validateFormFields(inputType, value));
  }

  handleInputBlurred(inputType) {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        [inputType]: true
      })
    }));
  }

  handlePath() {
    const { match: { url }, history, actionFetchUserProfile } = this.props;
    if (url === '/auth/login') {
      history.push('/');
      window.location.reload();
      actionFetchUserProfile();
    }
    window.location.reload();
  }

  handleAuthError(error) {
    switch (error.code) {
      case 'NotAuthorizedException':
      case 'UserNotFoundException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidCredentials: true
          })
        }));
        break;
      case 'CodeMismatchException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            verificationInvalid: true
          })
        }));
        break;
      case 'LimitExceededException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            LimitExceed: true
          })
        }));
        break;
      case 'InvalidPasswordException':
        this.setState(prevState => ({
          errors: Object.assign({}, prevState.errors, {
            invalidPassword: true
          })
        }));
        break;
      default:
        break;
    }
  }

  checkValues = (value, errorKey) => {
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.error, {
        [errorKey]: false
      }),
      blurredFields: Object.assign({}, prevState.error, {
        [value]: true
      })
    }));
  }

  handleSignIn(e) {
    const { phone, password, errors, newPassword, currentPage } = this.state;
    if (e) {
      e.preventDefault();
    }
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        invalidCredentials: false
      })
    }));
    if (phone) {
      this.checkValues('phone', 'phoneEmpty');
    }
    if (password) {
      this.checkValues('password', 'passwordEmpty');
    }
    if (!phone || !password) {
      if (errors.passwordEmpty) {
        this.setState(prevState => ({
          blurredFields: Object.assign({}, prevState.blurredFields, {
            phone: true,
            password: true
          })
        }));
        return;
      }
    }
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');

    const authDetails = new AuthenticationDetails({
      Username: phoneNumber,
      Password: currentPage === 'profile' ? newPassword : password
    });

    const cognitoUser = new CognitoUser({
      Username: phoneNumber,
      Pool: PortalAuth.getInstance().getUserPool()
    });

    this.setState({ cognitoUser });

    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        Auth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
        Auth.getInstance().setIDToken(result.getIdToken().getJwtToken());
        let token = result.getIdToken().getJwtToken().split('.')[1];
        token = Buffer.from(token, 'base64').toString();
        // eslint-disable-next-line no-undef
        localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
        fetchBackendUrl().then(() => {
          axios.defaults.baseURL = getBackendBaseUrl();
        }).then(() => {
          this.handlePath();
          this.props.actionFetchUserProfile();
        }).catch((err) => {
          console.log(err);
        });
      },
      onFailure: this.handleAuthError,
      newPasswordRequired: this.handleNewPasswordRequired
    });
  }

  handleUser = async (e) => {
    const { phone } = this.state;
    this.setState({ loadingStatus: true });
    e.preventDefault();
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    const cognitoUser = new CognitoUser({
      Username: phoneNumber,
      Pool: PortalAuth.getInstance().getUserPool()
    });

    Amplify.configure({
      Auth: {
        region: `${process.env.REACT_APP_REGION}`,
        userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
        userPoolWebClientId: `${process.env.REACT_APP_COGNITO_CLIENT_ID}`
      }
    });

    try {
      const cognitoUser = await Auth.signIn(phoneNumber);
      this.handleOpenOtpForm();
      this.setState({
        portalcognitoUser: cognitoUser,
        loadingStatus: false,
        resendSuccess: false
      });
    } catch (error) {
      this.setState({ cognitoPhoneError: true, loadingStatus: false });
      console.log(error);
    }
    this.setState({ cognitoUser });
  }

  handleResendOTP = async () => {
    const { phone } = this.state;
    console.log(phone);
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    this.setState({ resendSuccess: false, loadingStatus: true });
    try {
      const cognitoUser = await Auth.signIn(phoneNumber);
      this.setState({
        portalcognitoUser: cognitoUser,
        resendSuccess: true,
        loadingStatus: false
      });
    } catch (error) {
      this.setState({ loadingStatus: false });
      console.log(error);
    }
  }

  validateOtpField = () => {
    if (this.state.otp === '') {
      return true;
    }
    return false;
  }

  handleLogin = async (e) => {
    const { otp } = this.state;
    e.preventDefault();
    this.setState({ loadingStatus: true });
    const isOTPEmpty = this.validateOtpField();
    if (!isOTPEmpty) {
      Amplify.configure({
        Auth: {
          region: `${process.env.REACT_APP_REGION}`,
          userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
          userPoolWebClientId: `${process.env.REACT_APP_COGNITO_CLIENT_ID}`
        }
      });
      try {
        const cognitoUser = await Auth.sendCustomChallengeAnswer(this.state.portalcognitoUser, otp);
        PortalAuth.getInstance().setAuthToken(cognitoUser.signInUserSession.getAccessToken().getJwtToken());
        PortalAuth.getInstance().setIDToken(cognitoUser.signInUserSession.getIdToken().getJwtToken());
        let token = cognitoUser.signInUserSession.getIdToken().getJwtToken().split('.')[1];
        token = Buffer.from(token, 'base64').toString();
        // // eslint-disable-next-line no-undef
        localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
        fetchBackendUrl().then(() => {
          axios.defaults.baseURL = getBackendBaseUrl();
        }).then(() => {
          this.handlePath();
          this.props.actionFetchUserProfile();
          this.setState({ loadingStatus: false });
          const redirectUrl = localStorage.getItem('portalRedirectUrl');
          const baseLoginUrl = BASENAME + LOGIN_ROUTE;
          if ((redirectUrl !== null) && (redirectUrl !== baseLoginUrl)) {
            localStorage.removeItem('portalRedirectUrl');
            window.location.href = redirectUrl;
          }
        }).catch((err) => {
          console.log(err);
          this.setState({ loadingStatus: false });
        });
      // this.handlePath();
      // this.props.actionFetchUserProfile();
      } catch (error) {
        console.log(error.message);
        this.setState({ cognitoCodeError: true, loadingStatus: false });
      }
    } else {
      this.setState(prevState => ({
        errors: Object.assign({}, prevState.error, {
          codeEmpty: true
        }),
        blurredFields: Object.assign({}, prevState.error, {
          code: true
        }),
        cognitoCodeError: false,
        loadingStatus: false
      }));
    }
  }

  getUserData = (result) => {
    const {
      actionFetchUserProfile
    } = this.props;
    PortalAuth.getInstance().setAuthToken(result.getAccessToken().getJwtToken());
    PortalAuth.getInstance().setIDToken(result.getIdToken().getJwtToken());
    let token = result
      .getIdToken()
      .getJwtToken()
      .split('.')[1];
    token = Buffer.from(token, 'base64').toString();

    // eslint-disable-next-line no-undef
    localStorage.setItem('userId', JSON.parse(token)['cognito:username']);
    fetchBackendUrl()
      .then(() => {
        axios.defaults.baseURL = getBackendBaseUrl();
      })
      .then(() => {
        actionFetchUserProfile();
        this.handlePath();
        this.setState({ loadingStatus: false });
      })
      .catch((err) => {
        this.setState({ loadingStatus: false });
        console.log(err);
      });
  };

  handlePasswordLogin = (e) => {
    if (e) {
      e.preventDefault();
    }
    const { phone, password } = this.state;
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    this.setState({ loadingStatus: true });
    const cognitoUser = new CognitoUser({
      Username: phoneNumber,
      Pool: PortalAuth.getInstance().getUserPool()
    });
    this.setState({ cognitoUser });
    const authDetails = new AuthenticationDetails({
      Username: phoneNumber,
      Password: password
    });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        this.getUserData(result);
      },
      onFailure: this.handleAuthError
    });
    this.setState({ portalcognitoUser: cognitoUser, loadingStatus: false });
  }

  handlePhonePasswordLogin = () => {
    this.setState({ currentPage: 'phonePassword' });
  }

  handleMailLogin = () => {
    const { history } = this.props;
    history.push('/auth/email/login');
  }

   handleNewPasswordRequired = () => {
     this.setState({
       currentPage: 'forceChangePassword'
     });
   }

  //  When user clicks on Forgot Password
  handleForgotPassword = () => {
    this.setState(prevState => ({
      blurredFields: Object.assign({}, prevState.blurredFields, {
        phone: false
      }),
      errors: Object.assign({}, prevState.errors, {
        phoneEmpty: true,
        phoneInvalid: false
      }),
      phone: '',
      currentPage: 'forgot'
    }));
  }

  handleOTPLogin = () => {
    this.setState({ currentPage: 'otpLogin' });
  }

  handleOpenOtpForm = () => {
    this.setState({ currentPage: 'otpForm' });
  }

  handleChangeForgotPassword = () => {
    this.setState({
      currentPage: 'ChangeForgotpassword'
    });
  }

  //  Forgot password function
  handleForgotPasswordForm = (e) => {
    e.preventDefault();
    const { phone } = this.state;
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        invalidCredentials: false, LimitExceed: false
      })
    }));

    if (!phone) {
      this.setState(prevState => ({
        blurredFields: Object.assign({}, prevState.blurredFields, {
          phone: true
        })
      }));
      return;
    }

    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');

    const cognitoUser = new CognitoUser({
      Username: phoneNumber,
      Pool: Auth.getInstance().getUserPool()
    });

    cognitoUser.forgotPassword({
      onSuccess: () => {
        this.handleChangeForgotPassword();
      },
      onFailure: (err) => {
        this.handleAuthError(err);
      }
    });
  }

  handleNewPassword = (e) => {
    e.preventDefault();
    const { verificationCode, newPassword, phone } = this.state;

    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, {
        verificationInvalid: false, invalidPassword: false
      })
    }));

    if (verificationCode === '') {
      this.setState(prevState => ({
        errors: Object.assign({},
          prevState.errors,
          { verificationCodeEmpty: true })
      }));
      return;
    }
    if (newPassword === '') {
      this.setState(prevState => ({
        errors: Object.assign({},
          prevState.errors,
          { newPasswordEmpty: false })
      }));
      return;
    }
    let phoneNumber = phone;
    phoneNumber = phoneNumber[0] + phoneNumber.slice(1).replace(/[^\d]/g, '');
    const cognitoUser = new CognitoUser({
      Username: phoneNumber,
      Pool: Auth.getInstance().getUserPool()
    });
    cognitoUser.confirmPassword(verificationCode, newPassword,
      {
        onSuccess: () => {
          this.setState({ currentPage: 'login' });
        },
        onFailure: (err) => {
          this.handleAuthError(err);
        }
      });
  }

  render() {
    const {
      currentPage,
      errors,
      blurredFields,
      isChecked,
      password,
      cognitoUser,
      phone, otp,
      cognitoPhoneError,
      cognitoCodeError,
      loadingStatus,
      resendSuccess
    } = this.state;
    const { match: { url } } = this.props;
    let formToRender;
   if (currentPage === 'login') {
      formToRender = (
        <LoginForm
          handleInputChange={this.handleInputChange}
          handleSignIn={this.handleUser}
          errors={errors}
          url={url}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          onChangeRememberMe={this.onChangeRememberMe}
          isRemember={isChecked}
          phone={phone}
          password={password}
          handleForgotPassword={this.handleForgotPassword}
          handleOTPLogin={this.handleOTPLogin}
          cognitoPhoneError={cognitoPhoneError}
          handleLoginWithPassword={this.handlePhonePasswordLogin}
          handleMailLogin={this.handleMailLogin}
        />
      );
    } else if (currentPage === 'forceChangePassword') {
      formToRender = (
        <ForceChangePasswordForm
          cognitoUser={cognitoUser}
        />
      );
    } else if (currentPage === 'forgot') {
      formToRender = (
        <ForgotPasswordForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          phone={phone}
          handleForgotPasswordForm={this.handleForgotPasswordForm}
        />
      );
    } else if (currentPage === 'ChangeForgotpassword') {
      formToRender = (
        <NewPassword
          handleInputChange={this.handleInputChange}
          handleChangeForgotPasswordForm={this.handleNewPassword}
          errors={errors}
        />
      );
    } else if (currentPage === 'otpLogin') {
      formToRender = (
        <OTPLoginForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          phone={phone}
          handleUser={this.handleUser}
        />
      );
    } else if (currentPage === 'otpForm') {
      formToRender = (
        <OTPForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          cognitoCodeError={cognitoCodeError}
          otp={otp}
          handleLogin={this.handleLogin}
          handleResendOTP={this.handleResendOTP}
          resendSuccess={resendSuccess}
        />
      );
    } else if (currentPage === 'phonePassword') {
      formToRender = (
        <PasswordForm
          handleInputChange={this.handleInputChange}
          errors={errors}
          blurredFields={blurredFields}
          handleInputBlurred={this.handleInputBlurred}
          cognitoCodeError={cognitoCodeError}
          handleLogin={this.handlePasswordLogin}
          password={password}
        />
      );
    }
    return (
      <div className={styles.authentication}>
        <div className={styles.logo_container} style={{ flexDirection: 'row' }}>
          <img src={getLogo()} alt="logo" style={{ maxWidth: '37px' }} />
          <div className={styles.brand} style={{ fontSize: '37px', letterSpacing: '1px' }}>{getTitle()}</div>
        </div>
        <div className={styles.form_container}>
          {formToRender}
        </div>
        <Loading loadingStatus={loadingStatus} />
      </div>
    );
  }
}

Login.propTypes = {
  match: PropTypes.shape({}).isRequired,
  actionFetchUserProfile: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  actionFetchUserProfile: () => {
    dispatch(fetchUserProfile());
  },
  storeUserProfile: (profile) => {
    dispatch(updateUserProfile(profile));
  }
});

export default connect(null, mapDispatchToProps)(withRouter(Login));
